import React, { createContext, useContext, useState } from "react";

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isExpanded, setIsExpanded] = useState(true);

    const toggleDrawer = () => {
        setDrawerOpen((prev) => !prev);
    };

    const openDrawer = () => {
        setDrawerOpen(true);
    };

    const closeDrawer = () => {
        setDrawerOpen(false);
    };

    return (
        <SidebarContext.Provider
            value={{
                drawerOpen,
                setDrawerOpen,
                toggleDrawer,
                openDrawer,
                closeDrawer,
                isExpanded,
                setIsExpanded,
            }}
        >
            {children}
        </SidebarContext.Provider>
    );
};

export const useSidebar = () => {
    const context = useContext(SidebarContext);
    if (!context) {
        throw new Error("useSidebar must be used within a SidebarProvider");
    }
    return context;
};
